export const ACCENT_RED = '#f53331';
export const ACCENT_YELLOW = '#fdb935';
export const DEFAULT_DARK = '#14131e';
export const LIGHTER_DARK = '#2f2f2f';
export const DISABLED_GREY = 'grey';
export const DISABLED_LIGHT = '#e8e8e8';
export const SALMON = '#f89695';
